import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function PasswordInput({ name, onChange, onBlur }) {
    const [show, setShow] = useState(false);
    const { t } = useTranslation();

    const toggleShow = () => setShow(!show);
    const handleChange = (e) => {
        if (onChange)
            onChange(name, e.target.value);
    };

    const handleBlur = () => {
        if (onBlur)
            onBlur(name, true);
    };

    return (
        <>
            <div style={styles.inputContainer}>
                <input
                    type="text"
                    name={name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder={t("commons.password")}
                    autoComplete="off"
                    data-lpignore="true"
                    data-form-type="other"
                    style={{
                        ...styles.input,
                        WebkitTextSecurity: show ? "none" : "disc",
                    }}
                    required
                />
                <button
                    type="button"
                    onClick={toggleShow}
                    style={styles.toggleButton}
                    aria-label={t("commons.showHidePassword")}
                >
                    {show ? "🙈" : "👁️"}
                </button>
            </div>
        </>
    );
}

// Estilos inline simples
const styles = {
    form: {
        width: "300px",
        margin: "40px auto",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        fontFamily: "sans-serif",
    },
    label: {
        fontWeight: "bold",
    },
    inputContainer: {
        position: "relative",
        display: "flex",
        alignItems: "center",
    },
    input: {
        width: "100%",
        padding: "10px 40px 10px 10px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        fontSize: "16px",
    },
    toggleButton: {
        position: "absolute",
        right: "10px",
        background: "none",
        border: "none",
        cursor: "pointer",
        fontSize: "18px",
    },
    submitButton: {
        backgroundColor: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "8px",
        padding: "10px",
        cursor: "pointer",
        fontWeight: "bold",
    },
};